export default "__VITE_ASSET__b2e03e3c__"